export const DEFAULT_QUESTIONNAIRE_SECTIONS = {
  casas: [
    {
      id: 1,
      order: 1,
      title_jp: 'お問い合わせの目的',
      title_br: 'Objetivo do contato',
      title_us: 'Purpose of contact',
      title_es: 'Motivo del contacto',
      questions: [
        {
          id: 1,
          type: 'checkbox',
          required: false,
          text_jp: 'お問い合わせの目的',
          text_br: 'Objetivo do contato',
          text_us: 'Purpose of contact',
          text_es: 'Motivo del contacto',
          options: ['Quero comprar casa', 'Dúvida sobre financiamento', 'Histórico de crédito', 'Outros'],
        },
      ],
    },
    {
      id: 2,
      order: 2,
      title_jp: '個人情報',
      title_br: 'Dados Pessoais',
      title_us: 'Personal Data',
      title_es: 'Datos Personales',
      questions: [
        {
          id: 2,
          type: 'text',
          required: true,
          text_jp: '氏名',
          text_br: 'Nome completo',
          text_us: 'Full name',
          text_es: 'Nombre completo',
          options: [],
        },
        {
          id: 3,
          type: 'text',
          required: true,
          text_jp: 'メール',
          text_br: 'Email',
          text_us: 'Email',
          text_es: 'Correo',
          options: [],
        },
      ],
    },
    {
      id: 3,
      order: 3,
      title_jp: '希望条件',
      title_br: 'Preferências',
      title_us: 'Preferences',
      title_es: 'Preferencias',
      questions: [],
    },
  ],
  carros: [
    {
      id: 1,
      order: 1,
      title_jp: '車の種類',
      title_br: 'Tipo de Veículo',
      title_us: 'Vehicle Type',
      title_es: 'Tipo de Vehículo',
      questions: [],
    },
  ],
};
